import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'luxe_cookie_consent';

const CookieConsent = () => {
  const [isOpen, setIsOpen] = useState(() => !localStorage.getItem(CONSENT_KEY));

  useEffect(() => {
    const openSettings = () => setIsOpen(true);
    window.addEventListener('luxe:open-cookie-settings', openSettings);
    return () => window.removeEventListener('luxe:open-cookie-settings', openSettings);
  }, []);

  const saveChoice = choice => {
    localStorage.setItem(CONSENT_KEY, choice);
    window.dispatchEvent(new CustomEvent('luxe:cookie-consent', { detail: choice }));
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="cookie-title">
      <div className="mx-auto max-w-4xl rounded-2xl border border-border bg-background p-5 shadow-2xl sm:flex sm:items-center sm:gap-6">
        <div className="flex-1">
          <h2 id="cookie-title" className="text-lg font-semibold">Your cookie choices</h2>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
            We use privacy-preserving aggregate counts to improve the website without identifying visitors. With your permission, we also use Google Analytics for more detailed insights. Rejecting opts you out of both.{' '}
            <Link to="/privacy" className="text-primary underline underline-offset-2">Read our privacy and cookie notice</Link>.
          </p>
        </div>
        <div className="mt-4 grid gap-2 sm:mt-0 sm:min-w-52">
          <button type="button" onClick={() => saveChoice('accepted')} className="rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground hover:opacity-90">
            Accept analytics
          </button>
          <button type="button" onClick={() => saveChoice('rejected')} className="rounded-lg border border-border bg-background px-4 py-2.5 text-sm font-semibold hover:bg-muted">
            Reject non-essential
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
